import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "program-img-wrapper" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeaderWithMenu = _resolveComponent("PageHeaderWithMenu")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_item_option = _resolveComponent("ion-item-option")!
  const _component_ion_item_options = _resolveComponent("ion-item-options")!
  const _component_ion_item_sliding = _resolveComponent("ion-item-sliding")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_accordion = _resolveComponent("ion-accordion")!
  const _component_ion_accordion_group = _resolveComponent("ion-accordion-group")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_list_header = _resolveComponent("ion-list-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_reorder = _resolveComponent("ion-reorder")!
  const _component_ion_reorder_group = _resolveComponent("ion-reorder-group")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_loading = _resolveComponent("ion-loading")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_PageHeaderWithMenu, {
        title: "Миксы",
        scrolled: _ctx.headerScrolled
      }, null, 8, ["scrolled"]),
      _createVNode(_component_ion_content, {
        class: "main-background playlist-list-content",
        fullscreen: true,
        slot: "fixed",
        onIonScroll: _ctx.onContentScroll
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_segment, {
            value: _ctx.selectedListSegment,
            onIonChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.listSegmentChange($event))),
            mode: "md",
            class: "custom-segment"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_segment_button, { value: "all" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                      _createTextVNode("Все", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_segment_button, { value: "favourites" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                      _createTextVNode("Избранное", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"]),
          _withDirectives(_createVNode(_component_ion_content, { class: "bg-transparent" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_accordion_group, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.programs, (program, programIdx) => {
                    return (_openBlock(), _createElementBlock("div", { key: programIdx }, [
                      _createVNode(_component_ion_accordion, {
                        class: "bg-transparent",
                        value: program.programName
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, {
                            slot: "header",
                            class: "program-item",
                            lines: "none",
                            color: "violet"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_1, [
                                _createElementVNode("img", {
                                  src: _ctx.programLogos[program.shortName || ''] || _ctx.getProgramImage(program.shortName || ''),
                                  alt: "program logo"
                                }, null, 8, _hoisted_2)
                              ])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_ion_list, {
                            slot: "content",
                            class: "bg-transparent",
                            lines: "none"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createVNode(_component_ion_item, {
                                class: "release-item add-playlist-button",
                                onClick: ($event: any) => (_ctx.addPlayList(program.programName)),
                                color: "violet"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, { class: "ion-text-center" }, {
                                    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                      _createTextVNode("+", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick"]), [
                                [_vShow, !_ctx.globalContext.offlineMode]
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.playlistsByPrograms[
                  program.shortName || ''
                ], (playlist, playlistIdx) => {
                                return (_openBlock(), _createBlock(_component_ion_item_sliding, {
                                  name: "itemSliding-all",
                                  key: playlistIdx
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_item, {
                                      class: "release-item",
                                      detail: true,
                                      color: "violet"
                                    }, {
                                      default: _withCtx(() => [
                                        (playlist.offline)
                                          ? (_openBlock(), _createBlock(_component_ion_icon, {
                                              key: 0,
                                              slot: "start",
                                              icon: _ctx.checkmarkCircle,
                                              color: "success",
                                              class: "offline-indicator"
                                            }, null, 8, ["icon"]))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_ion_label, {
                                          class: "ion-text-center",
                                          onClick: ($event: any) => (_ctx.openPlaylist(playlist.id))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(playlist.name), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_ion_item_options, { side: "start" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_item_option, {
                                          color: "success",
                                          onClick: ($event: any) => (_ctx.copyPlaylist(playlist))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_icon, {
                                              slot: "icon-only",
                                              icon: _ctx.copy
                                            }, null, 8, ["icon"])
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_ion_item_options, {
                                      side: "end",
                                      onIonSwipe: ($event: any) => (_ctx.addToFavourites(playlist.id, playlist.favourite ? false : true))
                                    }, {
                                      default: _withCtx(() => [
                                        _withDirectives(_createVNode(_component_ion_item_option, {
                                          onClick: ($event: any) => (_ctx.changePlaylist(playlist.id)),
                                          color: "warning"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_icon, { icon: _ctx.createOutline }, null, 8, ["icon"])
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"]), [
                                          [_vShow, !playlist.isRelease]
                                        ]),
                                        _createVNode(_component_ion_item_option, {
                                          color: "danger",
                                          onClick: ($event: any) => (_ctx.confirmRemovement(playlist.id))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_icon, { icon: _ctx.trashOutline }, null, 8, ["icon"])
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"]),
                                        _withDirectives(_createVNode(_component_ion_item_option, {
                                          onClick: ($event: any) => (_ctx.addToFavourites(playlist.id, true)),
                                          color: "success",
                                          expandable: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_icon, { icon: _ctx.starOutline }, null, 8, ["icon"])
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"]), [
                                          [_vShow, !playlist.favourite]
                                        ]),
                                        _withDirectives(_createVNode(_component_ion_item_option, {
                                          onClick: ($event: any) => (_ctx.addToFavourites(playlist.id, false)),
                                          color: "success",
                                          class: "white-icon",
                                          expandable: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_icon, { icon: _ctx.star }, null, 8, ["icon"])
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"]), [
                                          [_vShow, playlist.favourite]
                                        ])
                                      ]),
                                      _: 2
                                    }, 1032, ["onIonSwipe"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["value"])
                    ]))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, {
                class: "bg-transparent fake-item",
                lines: "none"
              }),
              _createVNode(_component_ion_modal, {
                "is-open": _ctx.showEditPlaylist,
                onWillDismiss: _cache[10] || (_cache[10] = ($event: any) => (_ctx.closeTrackPreview()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_content, {
                    class: "playlist-container",
                    "scroll-y": false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_header, { mode: "md" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_toolbar, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_title, { class: "playlist-name" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.editPlaylist.name !== ""
                  ? _ctx.editPlaylist.name
                  : "Новый плейлист"), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_buttons, { slot: "primary" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_button, {
                                    class: "playlist-header-button",
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.savePlaylist()))
                                  }, {
                                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                      _createTextVNode("Сохранить", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_button, {
                                    class: "playlist-header-button",
                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeEditPlaylist()))
                                  }, {
                                    default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                      _createTextVNode(" Закрыть ", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_list, {
                        lines: "none",
                        class: "ion-margin-top"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, { class: "ion-margin-start ion-margin-end" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                  _createTextVNode("Название", -1)
                                ]))]),
                                _: 1
                              }),
                              _createVNode(_component_ion_input, {
                                type: "text",
                                modelValue: _ctx.editPlaylist.name,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editPlaylist.name) = $event)),
                                class: "playlist-name-input"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, { class: "ion-margin-start ion-margin-end" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                  _createTextVNode("Программа", -1)
                                ]))]),
                                _: 1
                              }),
                              _createVNode(_component_ion_select, {
                                value: _ctx.selectedProgram.programName,
                                modelValue: _ctx.selectedProgram,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedProgram) = $event)),
                                interface: "popover",
                                mode: "ios",
                                "interface-options": _ctx.customPopoverOptions,
                                onIonChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.programChanged()))
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.programs, (program) => {
                                    return (_openBlock(), _createBlock(_component_ion_select_option, {
                                      key: program.shortName,
                                      value: program
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(program.programName), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["value", "modelValue", "interface-options"])
                            ]),
                            _: 1
                          }),
                          _withDirectives(_createVNode(_component_ion_item, { class: "ion-margin-start ion-margin-end" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                  _createTextVNode("Релиз", -1)
                                ]))]),
                                _: 1
                              }),
                              _createVNode(_component_ion_select, {
                                value: _ctx.selectedRelease,
                                modelValue: _ctx.selectedRelease,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedRelease) = $event)),
                                interface: "popover",
                                mode: "ios",
                                "interface-options": _ctx.customPopoverOptions,
                                onIonChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.releaseChanged()))
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getProgramReleases(
                    _ctx.selectedProgram.programName
                  ), (release, idx) => {
                                    return (_openBlock(), _createBlock(_component_ion_select_option, {
                                      key: idx,
                                      value: release
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(release), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["value", "modelValue", "interface-options"])
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, _ctx.selectedProgram.programName !== '']
                          ]),
                          _withDirectives(_createElementVNode("div", {
                            class: _normalizeClass([
                'add-button-container',
                _ctx.releaseTracksVisible ? 'danger-background' : '',
              ])
                          }, [
                            _createVNode(_component_ion_button, {
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showReleaseTracks()))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  slot: "icon-only",
                                  icon: _ctx.add,
                                  class: _normalizeClass([_ctx.releaseTracksVisible ? 'close-button' : ''])
                                }, null, 8, ["icon", "class"])
                              ]),
                              _: 1
                            })
                          ], 2), [
                            [_vShow, _ctx.selectedRelease !== '']
                          ]),
                          _withDirectives(_createVNode(_component_ion_list, {
                            lines: "none",
                            class: "playlist-content ion-margin-bottom"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_list_header, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, { class: "playlist-header-label" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(`${_ctx.selectedProgram.programName} - ${_ctx.selectedRelease}`), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.mediaUtils.formatTime(
                      _ctx.mediaUtils.getTotalPlaylistDuration(_ctx.selectedTracks)
                    )), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_content, { forceOverscroll: true }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.musicList, (track, idx) => {
                                    return (_openBlock(), _createBlock(_component_ion_item, {
                                      key: idx,
                                      class: "preview-item"
                                    }, {
                                      default: _withCtx(() => [
                                        _withDirectives(_createElementVNode("div", {
                                          class: "preview-progress",
                                          style: _normalizeStyle({
                      width: `${(_ctx.previewCurrentPosition / _ctx.previewDuration) * 100
                        }%`,
                    })
                                        }, null, 4), [
                                          [_vShow, track.id == _ctx.previewTrackId]
                                        ]),
                                        _withDirectives(_createVNode(_component_ion_icon, {
                                          onClick: ($event: any) => (_ctx.previewTrack(track)),
                                          slot: "start",
                                          icon: _ctx.previewPlaying && track.id == _ctx.previewTrackId
                        ? _ctx.pause
                        : _ctx.play
                      ,
                                          class: "play-button"
                                        }, null, 8, ["onClick", "icon"]), [
                                          [_vShow, !_ctx.previewLoading || track.id !== _ctx.previewTrackId]
                                        ]),
                                        _withDirectives(_createVNode(_component_ion_spinner, {
                                          slot: "start",
                                          name: "bubbles"
                                        }, null, 512), [
                                          [_vShow, track.id == _ctx.previewTrackId && _ctx.previewLoading]
                                        ]),
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.mediaUtils.getTrackName(track)), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_ion_label, { slot: "end" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.mediaUtils.formatTime(track.duration)), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_ion_icon, {
                                          slot: "end",
                                          icon: _ctx.add,
                                          onClick: ($event: any) => (_ctx.addTrack(track)),
                                          class: _normalizeClass([
                      _ctx.isAdded(track)
                        ? 'close-button danger-button'
                        : 'add-button',
                    ])
                                        }, null, 8, ["icon", "onClick", "class"])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128)),
                                  _createVNode(_component_ion_item, {
                                    class: "fake-footer bg-transparent",
                                    lines: "none"
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, _ctx.releaseTracksVisible]
                          ]),
                          _withDirectives(_createVNode(_component_ion_list, {
                            lines: "none",
                            class: "playlist-content ion-margin-bottom"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_list_header, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, { class: "playlist-header-label" }, {
                                    default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                      _createTextVNode("Треки", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.mediaUtils.formatTime(
                      _ctx.mediaUtils.getTotalPlaylistDuration(_ctx.selectedTracks)
                    )), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _withDirectives(_createVNode(_component_ion_text, { class: "ion-margin-start" }, {
                                default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                  _createTextVNode(" Выберите программу и релиз ", -1)
                                ]))]),
                                _: 1
                              }, 512), [
                                [_vShow, _ctx.selectedRelease == '']
                              ]),
                              _createVNode(_component_ion_content, { forceOverscroll: true }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_reorder_group, {
                                    onIonItemReorder: _cache[9] || (_cache[9] = ($event: any) => (_ctx.reorderPlaylist($event))),
                                    disabled: false
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedTracks, (track) => {
                                        return (_openBlock(), _createBlock(_component_ion_item_sliding, {
                                          key: track.id
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_item, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_reorder, { slot: "start" }),
                                                _createVNode(_component_ion_label, null, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.mediaUtils.getTrackName(track)), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_ion_label, { slot: "end" }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.mediaUtils.formatTime(track.duration)), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_ion_item_options, { side: "end" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_item_option, {
                                                  onClick: ($event: any) => (_ctx.removeTrack(track)),
                                                  color: "danger"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_icon, { icon: _ctx.trashOutline }, null, 8, ["icon"])
                                                  ]),
                                                  _: 1
                                                }, 8, ["onClick"])
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_item, {
                                    class: "fake-footer bg-transparent",
                                    lines: "none"
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, !_ctx.releaseTracksVisible]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["is-open"])
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.selectedListSegment == 'all']
          ]),
          _withDirectives(_createVNode(_component_ion_content, { class: "bg-transparent favourites-content" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.programs, (program, programIdx) => {
                return (_openBlock(), _createElementBlock("div", { key: programIdx }, [
                  _createVNode(_component_ion_list, {
                    slot: "content",
                    class: "bg-transparent",
                    lines: "none"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.playlistsByPrograms[
              program.shortName || ''
            ], (playlist, playlistIdx) => {
                        return (_openBlock(), _createElementBlock("div", { key: playlistIdx }, [
                          (playlist.favourite)
                            ? (_openBlock(), _createBlock(_component_ion_item_sliding, {
                                key: 0,
                                name: "itemSliding-favourites"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_item, {
                                    class: "release-item release-favourite-item",
                                    detail: true,
                                    color: "violet"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, {
                                        class: "ion-text-center",
                                        onClick: ($event: any) => (_ctx.openPlaylist(playlist.id))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(`${playlist.programName} -
                                      ${playlist.name}`), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_item_options, { side: "start" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_item_option, {
                                        color: "success",
                                        onClick: ($event: any) => (_ctx.copyPlaylist(playlist))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_icon, {
                                            slot: "icon-only",
                                            icon: _ctx.copy
                                          }, null, 8, ["icon"])
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_item_options, {
                                    side: "end",
                                    onIonSwipe: ($event: any) => (_ctx.addToFavourites(playlist.id, playlist.favourite ? false : true))
                                  }, {
                                    default: _withCtx(() => [
                                      _withDirectives(_createVNode(_component_ion_item_option, {
                                        onClick: ($event: any) => (_ctx.changePlaylist(playlist.id)),
                                        color: "warning"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_icon, { icon: _ctx.createOutline }, null, 8, ["icon"])
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"]), [
                                        [_vShow, !playlist.isRelease]
                                      ]),
                                      _createVNode(_component_ion_item_option, {
                                        color: "danger",
                                        onClick: ($event: any) => (_ctx.confirmRemovement(playlist.id))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_icon, { icon: _ctx.trashOutline }, null, 8, ["icon"])
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"]),
                                      _withDirectives(_createVNode(_component_ion_item_option, {
                                        onClick: ($event: any) => (_ctx.addToFavourites(playlist.id, true)),
                                        color: "success",
                                        expandable: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_icon, { icon: _ctx.starOutline }, null, 8, ["icon"])
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"]), [
                                        [_vShow, !playlist.favourite]
                                      ]),
                                      _withDirectives(_createVNode(_component_ion_item_option, {
                                        onClick: ($event: any) => (_ctx.addToFavourites(playlist.id, false)),
                                        color: "success",
                                        expandable: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_icon, { icon: _ctx.star }, null, 8, ["icon"])
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"]), [
                                        [_vShow, playlist.favourite]
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["onIonSwipe"])
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1024)
                ]))
              }), 128)),
              _createVNode(_component_ion_item, {
                class: "bg-transparent fake-item",
                lines: "none"
              })
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.selectedListSegment == 'favourites']
          ]),
          _createVNode(_component_ion_loading, {
            cssClass: "liga-loading",
            spinner: "lines",
            "is-open": _ctx.isSavingRef,
            message: "Сохранение..."
          }, null, 8, ["is-open"])
        ]),
        _: 1
      }, 8, ["onIonScroll"])
    ]),
    _: 1
  }))
}